// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskRow-module__row___lbmr2 {
  width: 100%;
  display: grid;
  grid-template-columns: 14px 1fr 96px 90px 102px 62px;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  border: none;
  border-bottom: 1px solid #f4f4f5;
  background: #ffffff;
  transition: background 0.1s;
  text-align: left;
  appearance: none;
  font: inherit;
  border-left: 0 solid transparent;
}

.TaskRow-module__row___lbmr2:hover {
  background: #fafafa;
}

.TaskRow-module__row___lbmr2:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskRow-module__compact___BLCfd {
  grid-template-columns: 14px 1fr 62px;
  gap: 6px;
  padding: 8px 12px;
}

.TaskRow-module__selected___hURkB {
  background: #f4f4f5;
}

.TaskRow-module__selected___hURkB:hover {
  background: #f4f4f5;
}

.TaskRow-module__completedRow___SQJSt {
  background: #f0fdf4;
}

.TaskRow-module__completedRow___SQJSt:hover {
  background: #f0fdf4;
}

.TaskRow-module__unableToCompleteRow___XNySS,
.TaskRow-module__unableToCompleteRow___XNySS:hover {
  background: #fff7ed;
}

.TaskRow-module__completedSubtaskRow___FkU9_ {
  border-left: 2px solid #86efac;
  padding-left: 12px;
}

.TaskRow-module__linkedChildRow___zoh8Z {
  background: #ffffff;
}

.TaskRow-module__linkedChildRow___zoh8Z:hover {
  background: #fafafa;
}

.TaskRow-module__completedRow___SQJSt.TaskRow-module__linkedChildRow___zoh8Z,
.TaskRow-module__completedRow___SQJSt.TaskRow-module__linkedChildRow___zoh8Z:hover {
  background: #f0fdf4;
}

.TaskRow-module__subtaskChildRow___wj8rd {
  border-bottom: 1px solid #bfdbfe;
}

.TaskRow-module__completedRow___SQJSt.TaskRow-module__subtaskChildRow___wj8rd {
  border-left-color: #86efac;
  border-bottom-color: #86efac;
}

.TaskRow-module__unableToCompleteRow___XNySS.TaskRow-module__subtaskChildRow___wj8rd {
  border-left-color: #fdba74;
  border-bottom-color: #fdba74;
}

.TaskRow-module__rowPrioritycritical___gLefR {
  border-left: 4px solid #dc2626;
  padding-left: 10px;
}

.TaskRow-module__rowPriorityhigh___nOtaU {
  border-left: 4px solid #ea580c;
  padding-left: 10px;
}

.TaskRow-module__rowPrioritymedium___TjOdY {
  border-left: 3px solid #ca8a04;
  padding-left: 11px;
}

.TaskRow-module__rowPrioritylow___hYs3T {
  border-left: 2px solid #9ca3af;
  padding-left: 12px;
}

.TaskRow-module__rowPriorityLinked___Nd6i9 {
  border-left: 0 solid transparent;
  padding-left: 14px;
}

.TaskRow-module__rowPrioritySubtask___MWyhl {
  border-left: 2px solid #93c5fd;
  padding-left: 12px;
}

.TaskRow-module__completedRow___SQJSt.TaskRow-module__rowPrioritySubtask___MWyhl {
  border-left-color: #86efac;
}

.TaskRow-module__selectionCheckbox___DaDjk {
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: #18181b;
  margin: 0;
}

.TaskRow-module__checkBox___tsOAE {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
  border: 1.5px solid #d4d4d8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: #71717a;
}

.TaskRow-module__checkIcon___sw3L8 {
  width: 10px;
  height: 10px;
}

.TaskRow-module__checkCritical___K2PJX {
  border: 2px solid #18181b;
}

.TaskRow-module__checkFlagged___UcSEQ {
  border: 2px solid #71717a;
}

.TaskRow-module__checkUnableToComplete___UGSHC {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #c2410c;
}

.TaskRow-module__linkedIcon___NcEXi {
  width: 14px;
  height: 14px;
  color: #a1a1aa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.TaskRow-module__linkedIconGlyph___bsT3G {
  width: 10px;
  height: 10px;
}

.TaskRow-module__subtaskIcon___QKv3O {
  width: 14px;
  height: 14px;
  color: #a1a1aa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.TaskRow-module__subtaskIconGlyph___NeYyo {
  width: 12px;
  height: 12px;
}

.TaskRow-module__main___UtDzV {
  min-width: 0;
  overflow: hidden;
}

.TaskRow-module__titleRow___VFMLs {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.TaskRow-module__messageIcon___ZcHDu {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: #0b79b7;
  position: relative;
  flex-shrink: 0;
  margin-top: 1px;
}

.TaskRow-module__messageIcon___ZcHDu::before {
  content: "";
  position: absolute;
  left: 3px;
  top: 3px;
  width: 8px;
  height: 6px;
  border-radius: 2px;
  background: #ffffff;
}

.TaskRow-module__messageIcon___ZcHDu::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 8px;
  width: 4px;
  height: 4px;
  background: #ffffff;
  clip-path: polygon(0 0, 100% 0, 0 100%);
}

.TaskRow-module__assessmentIcon___yhsg1 {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: #7c3aed;
  position: relative;
  flex-shrink: 0;
  margin-top: 1px;
}

.TaskRow-module__assessmentIcon___yhsg1::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 2px;
  width: 6px;
  height: 9px;
  border-radius: 1px;
  border: 1.4px solid #ffffff;
  box-sizing: border-box;
}

.TaskRow-module__assessmentIcon___yhsg1::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 5px;
  width: 4px;
  height: 1px;
  background: #ffffff;
  box-shadow: 0 2px 0 #ffffff, 0 4px 0 #ffffff;
}

.TaskRow-module__criticalIcon___mO2w7 {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #dc2626;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.TaskRow-module__criticalIconGlyph___aHH3C {
  width: 12px;
  height: 12px;
}

.TaskRow-module__title___k_2Kz {
  flex: 0 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  color: #18181b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRow-module__completedTitle___AAMg0 {
  color: #71717a;
  text-decoration: line-through;
}

.TaskRow-module__compact___BLCfd .TaskRow-module__title___k_2Kz {
  font-size: 12px;
}

.TaskRow-module__subtaskAssignment___A0D5W {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex: 0 0 auto;
  font-size: 11px;
  color: #71717a;
  white-space: nowrap;
}

.TaskRow-module__subtaskAssignmentArrow___rCAiP {
  color: #a1a1aa;
  flex-shrink: 0;
}

.TaskRow-module__subtaskAssignmentTeam___d2RZO {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  white-space: nowrap;
}

.TaskRow-module__subtaskAssignmentTeamIcon___SgjAx {
  color: #9ca3af;
  flex-shrink: 0;
  line-height: 1;
}

.TaskRow-module__subtaskAssignmentDivider___p00hh {
  color: #a1a1aa;
  flex-shrink: 0;
}

.TaskRow-module__subtaskAssignmentOwner___k2Rqe {
  white-space: nowrap;
}

.TaskRow-module__linkedFromRow____2YJ2 {
  font-size: 11px;
  color: #64748b;
  font-style: italic;
  margin-top: 1px;
}

.TaskRow-module__reasonRow___thrpY {
  font-size: 11px;
  font-weight: 600;
  color: #52525b;
  margin-top: 2px;
}

.TaskRow-module__edgeBadge___sp2Gs {
  font-size: 9px;
  line-height: 16px;
  padding: 0 4px;
  flex-shrink: 0;
}

.TaskRow-module__caption___ZGyzh {
  font-size: 11px;
  color: #71717a;
  line-height: 1.4;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.TaskRow-module__captionCompact___M_Gfx {
  white-space: nowrap;
  display: block;
}

.TaskRow-module__waitingOnRow___beDbR {
  grid-column: 1/3;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 4px;
  font-size: 11px;
  color: #a1a1aa;
  min-width: 0;
  border: 1px dashed #d4d4d8;
  border-radius: 4px;
  padding: 2px 6px;
}

.TaskRow-module__waitingOnIcon___Q056L {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  margin-top: 1px;
}

.TaskRow-module__waitingOnLabel___LyD38 {
  flex-shrink: 0;
}

.TaskRow-module__waitingOnTitle___Yhk5b {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRow-module__subtaskOfRow___MxdkA {
  grid-column: 1/3;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 4px;
  font-size: 11px;
  color: #0b79b7;
  min-width: 0;
  border: 1px dashed #93c5fd;
  border-radius: 4px;
  padding: 2px 6px;
  background: #eff6ff;
}

.TaskRow-module__completedRow___SQJSt .TaskRow-module__subtaskOfRow___MxdkA {
  color: #166534;
  border-color: #86efac;
  background: #dcfce7;
}

.TaskRow-module__subtaskOfIcon___SuTYW {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  margin-top: 1px;
}

.TaskRow-module__parentReadyRow___e1Eno {
  grid-column: 1/3;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 4px;
  font-size: 11px;
  color: #166534;
  min-width: 0;
  border: 1px dashed #86efac;
  border-radius: 4px;
  padding: 2px 6px;
  background: #f0fdf4;
}

.TaskRow-module__parentReadyIcon___OYvni {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  margin-top: 1px;
}

.TaskRow-module__parentReadyTitle___f4tBX {
  min-width: 0;
  font-weight: 500;
}

.TaskRow-module__subtaskOfTitle___Ii4Xs {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRow-module__metaRow___yvWs0 {
  font-size: 11px;
  color: #a1a1aa;
  margin-top: 2px;
}

.TaskRow-module__statusCell___xsxIZ {
  display: flex;
  align-items: center;
}

.TaskRow-module__childCountBadge___NA8M8 {
  gap: 5px;
  background: #eff6ff;
  color: #0b79b7;
  border: 1px solid #93c5fd;
}

.TaskRow-module__childCountBadgeItem___PCTjM {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.TaskRow-module__childCountBadgeIcon___pwuDJ {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
}

.TaskRow-module__childCountBadgeDivider___EK33V {
  color: #60a5fa;
}

.TaskRow-module__priorityCell___T5iOw {
  display: flex;
  align-items: center;
  gap: 6px;
}

.TaskRow-module__assignCell___bP8Io {
  display: flex;
  align-items: center;
}

.TaskRow-module__systemBadge___FoYvH {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 7px;
  border-radius: 6px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.TaskRow-module__priorityBadge___cj9T6 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}

.TaskRow-module__copyButton___C5voL {
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.TaskRow-module__copyButton___C5voL:hover:not(:disabled) {
  background: #f4f4f5;
  color: #52525b;
}

.TaskRow-module__copyButton___C5voL:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.TaskRow-module__copyButton___C5voL:disabled {
  cursor: default;
  opacity: 0.45;
}

.TaskRow-module__copyIcon___PFhSY {
  width: 14px;
  height: 14px;
}

.TaskRow-module__priorityBadgecritical___kKr1e {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
  font-weight: 600;
}

.TaskRow-module__priorityBadgehigh___VqUzM {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.TaskRow-module__priorityBadgemedium___rcMkk {
  background: #fefce8;
  border-color: #fef08a;
  color: #a16207;
}

.TaskRow-module__priorityBadgelow___CGs4g {
  background: #f9fafb;
  border-color: #e5e7eb;
  color: #6b7280;
}

.TaskRow-module__assignButton___hGzcE {
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #18181b;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.TaskRow-module__assignButton___hGzcE:hover:not(:disabled) {
  background: #18181b;
  border-color: #18181b;
  color: #fafafa;
  box-shadow: 0 4px 10px rgba(24, 24, 27, 0.2);
  transform: translateY(-1px);
}

.TaskRow-module__assignButton___hGzcE:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.TaskRow-module__assignButtonOver___w3UKW {
  border-color: #fbbf24;
  color: #92400e;
}

.TaskRow-module__assignButtonOver___w3UKW:hover:not(:disabled) {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
  box-shadow: none;
  transform: none;
}

.TaskRow-module__assignButtonBreach___uawMa {
  border-color: #fca5a5;
  color: #b91c1c;
}

.TaskRow-module__assignButtonBreach___uawMa:hover:not(:disabled) {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
  box-shadow: none;
  transform: none;
}

.TaskRow-module__claimCapacityBanner___yTmgc {
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: default;
}

.TaskRow-module__claimCapacityBannerOver___FCjnK {
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.TaskRow-module__claimCapacityBannerBreach___svABl {
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.TaskRow-module__claimCapacityBannerRow___Ek5DZ {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.TaskRow-module__claimCapacityIcon___mqXtF {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  margin-top: 1px;
}

.TaskRow-module__claimCapacityIconOver___r5rUN {
  color: #b45309;
}

.TaskRow-module__claimCapacityIconBreach___oy2jN {
  color: #b91c1c;
}

.TaskRow-module__claimCapacityBannerText___SwWTT {
  font-size: 11px;
  line-height: 1.4;
  color: #52525b;
}

.TaskRow-module__tOver___sB5B9 {
  color: #92400e;
}

.TaskRow-module__tBreach___PEjgG {
  color: #b91c1c;
}

.TaskRow-module__claimCapacityMeterWrap___yodZW {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.TaskRow-module__claimCapacityTrack___e4H0q {
  position: relative;
  height: 8px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 3px;
  overflow: hidden;
}

.TaskRow-module__claimCapacityFillAmber___DyJ7W,
.TaskRow-module__claimCapacityFillRed___pomKN,
.TaskRow-module__claimCapacityFillAmberHatch___k9GeF,
.TaskRow-module__claimCapacityFillRedHatch___vTFEg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

.TaskRow-module__claimCapacityFillAmber___DyJ7W {
  background: #fcd34d;
}

.TaskRow-module__claimCapacityFillRed___pomKN {
  background: #ef4444;
}

.TaskRow-module__claimCapacityFillAmberHatch___k9GeF {
  background: repeating-linear-gradient(45deg, #eab308 0 3px, #fde68a 3px 6px);
}

.TaskRow-module__claimCapacityFillRedHatch___vTFEg {
  background: repeating-linear-gradient(45deg, #ef4444 0 3px, #fecaca 3px 6px);
}

.TaskRow-module__claimCapacityTickNow____YEe8 {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgba(107, 114, 128, 0.6);
}

.TaskRow-module__claimCapacityTickCap___vu05P {
  position: absolute;
  top: -1px;
  bottom: -1px;
  width: 1.5px;
  background: #18181b;
}

.TaskRow-module__claimCapacityLabels___MaMET {
  position: relative;
  height: 11px;
  font-size: 9.5px;
  color: #71717a;
}

.TaskRow-module__claimCapacityLabelNow___GrC8d {
  position: absolute;
  left: 0;
}

.TaskRow-module__claimCapacityLabelCap___FmRmg {
  position: absolute;
  transform: translateX(-50%);
  white-space: nowrap;
}

.TaskRow-module__assignButton___hGzcE:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskRow-module__dueText___laLQW {
  font-size: 11px;
  font-weight: 400;
  color: #a1a1aa;
  font-family: "IBM Plex Mono", monospace;
  text-align: right;
  white-space: nowrap;
}

.TaskRow-module__dueUrgent____QpWw {
  font-weight: 600;
  color: #18181b;
}

.TaskRow-module__completedRow___SQJSt .TaskRow-module__checkBox___tsOAE {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.TaskRow-module__unableToCompleteRow___XNySS .TaskRow-module__checkBox___tsOAE {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #c2410c;
}

.TaskRow-module__completedRow___SQJSt .TaskRow-module__caption___ZGyzh,
.TaskRow-module__completedRow___SQJSt .TaskRow-module__metaRow___yvWs0,
.TaskRow-module__completedRow___SQJSt .TaskRow-module__waitingOnRow___beDbR,
.TaskRow-module__completedRow___SQJSt .TaskRow-module__linkedToggle___Xgkev {
  color: #71717a;
}

.TaskRow-module__completedRow___SQJSt .TaskRow-module__dueText___laLQW {
  color: #166534;
  font-weight: 500;
}

.TaskRow-module__unableToCompleteRow___XNySS .TaskRow-module__dueText___laLQW {
  color: #c2410c;
  font-weight: 500;
}

.TaskRow-module__completedRow___SQJSt .TaskRow-module__copyButton___C5voL:hover:not(:disabled) {
  background: #dcfce7;
  color: #166534;
}

.TaskRow-module__unableToCompleteRow___XNySS .TaskRow-module__copyButton___C5voL:hover:not(:disabled) {
  background: #fed7aa;
  color: #9a3412;
}

.TaskRow-module__linkedToggle___Xgkev {
  grid-column: 1/7;
  margin-top: 2px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  cursor: pointer;
  font-size: 11px;
  line-height: 1.2;
}

.TaskRow-module__linkedToggle___Xgkev:hover {
  color: #52525b;
}

.TaskRow-module__linkedToggle___Xgkev:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
  border-radius: 4px;
}

.TaskRow-module__linkedToggleChevron___Q1Skf,
.TaskRow-module__linkedToggleIcon___DypCc {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.TaskRow-module__linkedToggleChevron___Q1Skf {
  transition: transform 0.15s ease;
}

.TaskRow-module__linkedToggleChevronOpen___dU6Sx {
  transform: rotate(90deg);
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/TaskRow/TaskRow.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,oDAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,oCAAA;EACA,QAAA;EACA,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,0BAAA;EACA,4BAAA;AACF;;AAEA;EACE,0BAAA;EACA,4BAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,gCAAA;EACA,kBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,4CACE;AAAJ;;AAIA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,6BAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,cAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,QAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,aAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,6GACE;AAFJ;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,4CAAA;EACA,2BAAA;AALF;;AAQA;EACE,mBAAA;EACA,YAAA;AALF;;AAQA;EACE,qBAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,qBAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AALF;;AAQA;EACE,mBAAA;EACA,yBAAA;AALF;;AAQA;EACE,mBAAA;EACA,yBAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AALF;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;;;;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,4EAAA;AALF;;AAQA;EACE,4EAAA;AALF;;AAQA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;AALF;;AAQA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AALF;;AAQA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,kBAAA;EACA,OAAA;AALF;;AAQA;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;AALF;;AAQA;EACE,0BAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;EACA,iBAAA;EACA,mBAAA;AALF;;AAQA;EACE,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AALF;;AAQA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AALF;;AAQA;;;;EAIE,cAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,mBAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,cAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AALF;;AAQA;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;AALF;;AAQA;EACE,gCAAA;AALF;;AAQA;EACE,wBAAA;AALF","sourcesContent":[".row {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 14px 1fr 96px 90px 102px 62px;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  cursor: pointer;\n  border: none;\n  border-bottom: 1px solid #f4f4f5;\n  background: #ffffff;\n  transition: background 0.1s;\n  text-align: left;\n  appearance: none;\n  font: inherit;\n  border-left: 0 solid transparent;\n}\n\n.row:hover {\n  background: #fafafa;\n}\n\n.row:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.compact {\n  grid-template-columns: 14px 1fr 62px;\n  gap: 6px;\n  padding: 8px 12px;\n}\n\n.selected {\n  background: #f4f4f5;\n}\n\n.selected:hover {\n  background: #f4f4f5;\n}\n\n.completedRow {\n  background: #f0fdf4;\n}\n\n.completedRow:hover {\n  background: #f0fdf4;\n}\n\n.unableToCompleteRow,\n.unableToCompleteRow:hover {\n  background: #fff7ed;\n}\n\n.completedSubtaskRow {\n  border-left: 2px solid #86efac;\n  padding-left: 12px;\n}\n\n.linkedChildRow {\n  background: #ffffff;\n}\n\n.linkedChildRow:hover {\n  background: #fafafa;\n}\n\n.completedRow.linkedChildRow,\n.completedRow.linkedChildRow:hover {\n  background: #f0fdf4;\n}\n\n.subtaskChildRow {\n  border-bottom: 1px solid #bfdbfe;\n}\n\n.completedRow.subtaskChildRow {\n  border-left-color: #86efac;\n  border-bottom-color: #86efac;\n}\n\n.unableToCompleteRow.subtaskChildRow {\n  border-left-color: #fdba74;\n  border-bottom-color: #fdba74;\n}\n\n.rowPrioritycritical {\n  border-left: 4px solid #dc2626;\n  padding-left: 10px;\n}\n\n.rowPriorityhigh {\n  border-left: 4px solid #ea580c;\n  padding-left: 10px;\n}\n\n.rowPrioritymedium {\n  border-left: 3px solid #ca8a04;\n  padding-left: 11px;\n}\n\n.rowPrioritylow {\n  border-left: 2px solid #9ca3af;\n  padding-left: 12px;\n}\n\n.rowPriorityLinked {\n  border-left: 0 solid transparent;\n  padding-left: 14px;\n}\n\n.rowPrioritySubtask {\n  border-left: 2px solid #93c5fd;\n  padding-left: 12px;\n}\n\n.completedRow.rowPrioritySubtask {\n  border-left-color: #86efac;\n}\n\n.selectionCheckbox {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n  accent-color: #18181b;\n  margin: 0;\n}\n\n.checkBox {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  flex-shrink: 0;\n  border: 1.5px solid #d4d4d8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 8px;\n  color: #71717a;\n}\n\n.checkIcon {\n  width: 10px;\n  height: 10px;\n}\n\n.checkCritical {\n  border: 2px solid #18181b;\n}\n\n.checkFlagged {\n  border: 2px solid #71717a;\n}\n\n.checkUnableToComplete {\n  border-color: #fed7aa;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.linkedIcon {\n  width: 14px;\n  height: 14px;\n  color: #a1a1aa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.linkedIconGlyph {\n  width: 10px;\n  height: 10px;\n}\n\n.subtaskIcon {\n  width: 14px;\n  height: 14px;\n  color: #a1a1aa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.subtaskIconGlyph {\n  width: 12px;\n  height: 12px;\n}\n\n.main {\n  min-width: 0;\n  overflow: hidden;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n}\n\n.messageIcon {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  background: #0b79b7;\n  position: relative;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.messageIcon::before {\n  content: '';\n  position: absolute;\n  left: 3px;\n  top: 3px;\n  width: 8px;\n  height: 6px;\n  border-radius: 2px;\n  background: #ffffff;\n}\n\n.messageIcon::after {\n  content: '';\n  position: absolute;\n  left: 4px;\n  top: 8px;\n  width: 4px;\n  height: 4px;\n  background: #ffffff;\n  clip-path: polygon(0 0, 100% 0, 0 100%);\n}\n\n.assessmentIcon {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  background: #7c3aed;\n  position: relative;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.assessmentIcon::before {\n  content: '';\n  position: absolute;\n  left: 4px;\n  top: 2px;\n  width: 6px;\n  height: 9px;\n  border-radius: 1px;\n  border: 1.4px solid #ffffff;\n  box-sizing: border-box;\n}\n\n.assessmentIcon::after {\n  content: '';\n  position: absolute;\n  left: 5px;\n  top: 5px;\n  width: 4px;\n  height: 1px;\n  background: #ffffff;\n  box-shadow:\n    0 2px 0 #ffffff,\n    0 4px 0 #ffffff;\n}\n\n.criticalIcon {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #dc2626;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.criticalIconGlyph {\n  width: 12px;\n  height: 12px;\n}\n\n.title {\n  flex: 0 1 auto;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #18181b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.completedTitle {\n  color: #71717a;\n  text-decoration: line-through;\n}\n\n.compact .title {\n  font-size: 12px;\n}\n\n.subtaskAssignment {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  flex: 0 0 auto;\n  font-size: 11px;\n  color: #71717a;\n  white-space: nowrap;\n}\n\n.subtaskAssignmentArrow {\n  color: #a1a1aa;\n  flex-shrink: 0;\n}\n\n.subtaskAssignmentTeam {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  white-space: nowrap;\n}\n\n.subtaskAssignmentTeamIcon {\n  color: #9ca3af;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.subtaskAssignmentDivider {\n  color: #a1a1aa;\n  flex-shrink: 0;\n}\n\n.subtaskAssignmentOwner {\n  white-space: nowrap;\n}\n\n.linkedFromRow {\n  font-size: 11px;\n  color: #64748b;\n  font-style: italic;\n  margin-top: 1px;\n}\n\n.reasonRow {\n  font-size: 11px;\n  font-weight: 600;\n  color: #52525b;\n  margin-top: 2px;\n}\n\n.edgeBadge {\n  font-size: 9px;\n  line-height: 16px;\n  padding: 0 4px;\n  flex-shrink: 0;\n}\n\n.caption {\n  font-size: 11px;\n  color: #71717a;\n  line-height: 1.4;\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.captionCompact {\n  white-space: nowrap;\n  display: block;\n}\n\n.waitingOnRow {\n  grid-column: 1 / 3;\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  margin-top: 4px;\n  font-size: 11px;\n  color: #a1a1aa;\n  min-width: 0;\n  border: 1px dashed #d4d4d8;\n  border-radius: 4px;\n  padding: 2px 6px;\n}\n\n.waitingOnIcon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.waitingOnLabel {\n  flex-shrink: 0;\n}\n\n.waitingOnTitle {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subtaskOfRow {\n  grid-column: 1 / 3;\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  margin-top: 4px;\n  font-size: 11px;\n  color: #0b79b7;\n  min-width: 0;\n  border: 1px dashed #93c5fd;\n  border-radius: 4px;\n  padding: 2px 6px;\n  background: #eff6ff;\n}\n\n.completedRow .subtaskOfRow {\n  color: #166534;\n  border-color: #86efac;\n  background: #dcfce7;\n}\n\n.subtaskOfIcon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.parentReadyRow {\n  grid-column: 1 / 3;\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  margin-top: 4px;\n  font-size: 11px;\n  color: #166534;\n  min-width: 0;\n  border: 1px dashed #86efac;\n  border-radius: 4px;\n  padding: 2px 6px;\n  background: #f0fdf4;\n}\n\n.parentReadyIcon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.parentReadyTitle {\n  min-width: 0;\n  font-weight: 500;\n}\n\n.subtaskOfTitle {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.metaRow {\n  font-size: 11px;\n  color: #a1a1aa;\n  margin-top: 2px;\n}\n\n.statusCell {\n  display: flex;\n  align-items: center;\n}\n\n.childCountBadge {\n  gap: 5px;\n  background: #eff6ff;\n  color: #0b79b7;\n  border: 1px solid #93c5fd;\n}\n\n.childCountBadgeItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.childCountBadgeIcon {\n  width: 10px;\n  height: 10px;\n  flex-shrink: 0;\n}\n\n.childCountBadgeDivider {\n  color: #60a5fa;\n}\n\n.priorityCell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.assignCell {\n  display: flex;\n  align-items: center;\n}\n\n.systemBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px 7px;\n  border-radius: 6px;\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.priorityBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 6px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.copyButton {\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.copyButton:hover:not(:disabled) {\n  background: #f4f4f5;\n  color: #52525b;\n}\n\n.copyButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 1px;\n}\n\n.copyButton:disabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.copyIcon {\n  width: 14px;\n  height: 14px;\n}\n\n.priorityBadgecritical {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.priorityBadgehigh {\n  background: #fff7ed;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n\n.priorityBadgemedium {\n  background: #fefce8;\n  border-color: #fef08a;\n  color: #a16207;\n}\n\n.priorityBadgelow {\n  background: #f9fafb;\n  border-color: #e5e7eb;\n  color: #6b7280;\n}\n\n.assignButton {\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #18181b;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n}\n\n.assignButton:hover:not(:disabled) {\n  background: #18181b;\n  border-color: #18181b;\n  color: #fafafa;\n  box-shadow: 0 4px 10px rgba(24, 24, 27, 0.2);\n  transform: translateY(-1px);\n}\n\n.assignButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.assignButtonOver {\n  border-color: #fbbf24;\n  color: #92400e;\n}\n\n.assignButtonOver:hover:not(:disabled) {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #92400e;\n  box-shadow: none;\n  transform: none;\n}\n\n.assignButtonBreach {\n  border-color: #fca5a5;\n  color: #b91c1c;\n}\n\n.assignButtonBreach:hover:not(:disabled) {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b91c1c;\n  box-shadow: none;\n  transform: none;\n}\n\n.claimCapacityBanner {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 6px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  cursor: default;\n}\n\n.claimCapacityBannerOver {\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n}\n\n.claimCapacityBannerBreach {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n}\n\n.claimCapacityBannerRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.claimCapacityIcon {\n  width: 13px;\n  height: 13px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.claimCapacityIconOver {\n  color: #b45309;\n}\n\n.claimCapacityIconBreach {\n  color: #b91c1c;\n}\n\n.claimCapacityBannerText {\n  font-size: 11px;\n  line-height: 1.4;\n  color: #52525b;\n}\n\n.tOver {\n  color: #92400e;\n}\n\n.tBreach {\n  color: #b91c1c;\n}\n\n.claimCapacityMeterWrap {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.claimCapacityTrack {\n  position: relative;\n  height: 8px;\n  background: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.claimCapacityFillAmber,\n.claimCapacityFillRed,\n.claimCapacityFillAmberHatch,\n.claimCapacityFillRedHatch {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n}\n\n.claimCapacityFillAmber {\n  background: #fcd34d;\n}\n\n.claimCapacityFillRed {\n  background: #ef4444;\n}\n\n.claimCapacityFillAmberHatch {\n  background: repeating-linear-gradient(45deg, #eab308 0 3px, #fde68a 3px 6px);\n}\n\n.claimCapacityFillRedHatch {\n  background: repeating-linear-gradient(45deg, #ef4444 0 3px, #fecaca 3px 6px);\n}\n\n.claimCapacityTickNow {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: rgba(107, 114, 128, 0.6);\n}\n\n.claimCapacityTickCap {\n  position: absolute;\n  top: -1px;\n  bottom: -1px;\n  width: 1.5px;\n  background: #18181b;\n}\n\n.claimCapacityLabels {\n  position: relative;\n  height: 11px;\n  font-size: 9.5px;\n  color: #71717a;\n}\n\n.claimCapacityLabelNow {\n  position: absolute;\n  left: 0;\n}\n\n.claimCapacityLabelCap {\n  position: absolute;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n\n.assignButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.dueText {\n  font-size: 11px;\n  font-weight: 400;\n  color: #a1a1aa;\n  font-family: 'IBM Plex Mono', monospace;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.dueUrgent {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.completedRow .checkBox {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.unableToCompleteRow .checkBox {\n  border-color: #fed7aa;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.completedRow .caption,\n.completedRow .metaRow,\n.completedRow .waitingOnRow,\n.completedRow .linkedToggle {\n  color: #71717a;\n}\n\n.completedRow .dueText {\n  color: #166534;\n  font-weight: 500;\n}\n\n.unableToCompleteRow .dueText {\n  color: #c2410c;\n  font-weight: 500;\n}\n\n.completedRow .copyButton:hover:not(:disabled) {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.unableToCompleteRow .copyButton:hover:not(:disabled) {\n  background: #fed7aa;\n  color: #9a3412;\n}\n\n.linkedToggle {\n  grid-column: 1 / 7;\n  margin-top: 2px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  width: fit-content;\n  cursor: pointer;\n  font-size: 11px;\n  line-height: 1.2;\n}\n\n.linkedToggle:hover {\n  color: #52525b;\n}\n\n.linkedToggle:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.linkedToggleChevron,\n.linkedToggleIcon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.linkedToggleChevron {\n  transition: transform 0.15s ease;\n}\n\n.linkedToggleChevronOpen {\n  transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `TaskRow-module__row___lbmr2`,
	"compact": `TaskRow-module__compact___BLCfd`,
	"selected": `TaskRow-module__selected___hURkB`,
	"completedRow": `TaskRow-module__completedRow___SQJSt`,
	"unableToCompleteRow": `TaskRow-module__unableToCompleteRow___XNySS`,
	"completedSubtaskRow": `TaskRow-module__completedSubtaskRow___FkU9_`,
	"linkedChildRow": `TaskRow-module__linkedChildRow___zoh8Z`,
	"subtaskChildRow": `TaskRow-module__subtaskChildRow___wj8rd`,
	"rowPrioritycritical": `TaskRow-module__rowPrioritycritical___gLefR`,
	"rowPriorityhigh": `TaskRow-module__rowPriorityhigh___nOtaU`,
	"rowPrioritymedium": `TaskRow-module__rowPrioritymedium___TjOdY`,
	"rowPrioritylow": `TaskRow-module__rowPrioritylow___hYs3T`,
	"rowPriorityLinked": `TaskRow-module__rowPriorityLinked___Nd6i9`,
	"rowPrioritySubtask": `TaskRow-module__rowPrioritySubtask___MWyhl`,
	"selectionCheckbox": `TaskRow-module__selectionCheckbox___DaDjk`,
	"checkBox": `TaskRow-module__checkBox___tsOAE`,
	"checkIcon": `TaskRow-module__checkIcon___sw3L8`,
	"checkCritical": `TaskRow-module__checkCritical___K2PJX`,
	"checkFlagged": `TaskRow-module__checkFlagged___UcSEQ`,
	"checkUnableToComplete": `TaskRow-module__checkUnableToComplete___UGSHC`,
	"linkedIcon": `TaskRow-module__linkedIcon___NcEXi`,
	"linkedIconGlyph": `TaskRow-module__linkedIconGlyph___bsT3G`,
	"subtaskIcon": `TaskRow-module__subtaskIcon___QKv3O`,
	"subtaskIconGlyph": `TaskRow-module__subtaskIconGlyph___NeYyo`,
	"main": `TaskRow-module__main___UtDzV`,
	"titleRow": `TaskRow-module__titleRow___VFMLs`,
	"messageIcon": `TaskRow-module__messageIcon___ZcHDu`,
	"assessmentIcon": `TaskRow-module__assessmentIcon___yhsg1`,
	"criticalIcon": `TaskRow-module__criticalIcon___mO2w7`,
	"criticalIconGlyph": `TaskRow-module__criticalIconGlyph___aHH3C`,
	"title": `TaskRow-module__title___k_2Kz`,
	"completedTitle": `TaskRow-module__completedTitle___AAMg0`,
	"subtaskAssignment": `TaskRow-module__subtaskAssignment___A0D5W`,
	"subtaskAssignmentArrow": `TaskRow-module__subtaskAssignmentArrow___rCAiP`,
	"subtaskAssignmentTeam": `TaskRow-module__subtaskAssignmentTeam___d2RZO`,
	"subtaskAssignmentTeamIcon": `TaskRow-module__subtaskAssignmentTeamIcon___SgjAx`,
	"subtaskAssignmentDivider": `TaskRow-module__subtaskAssignmentDivider___p00hh`,
	"subtaskAssignmentOwner": `TaskRow-module__subtaskAssignmentOwner___k2Rqe`,
	"linkedFromRow": `TaskRow-module__linkedFromRow____2YJ2`,
	"reasonRow": `TaskRow-module__reasonRow___thrpY`,
	"edgeBadge": `TaskRow-module__edgeBadge___sp2Gs`,
	"caption": `TaskRow-module__caption___ZGyzh`,
	"captionCompact": `TaskRow-module__captionCompact___M_Gfx`,
	"waitingOnRow": `TaskRow-module__waitingOnRow___beDbR`,
	"waitingOnIcon": `TaskRow-module__waitingOnIcon___Q056L`,
	"waitingOnLabel": `TaskRow-module__waitingOnLabel___LyD38`,
	"waitingOnTitle": `TaskRow-module__waitingOnTitle___Yhk5b`,
	"subtaskOfRow": `TaskRow-module__subtaskOfRow___MxdkA`,
	"subtaskOfIcon": `TaskRow-module__subtaskOfIcon___SuTYW`,
	"parentReadyRow": `TaskRow-module__parentReadyRow___e1Eno`,
	"parentReadyIcon": `TaskRow-module__parentReadyIcon___OYvni`,
	"parentReadyTitle": `TaskRow-module__parentReadyTitle___f4tBX`,
	"subtaskOfTitle": `TaskRow-module__subtaskOfTitle___Ii4Xs`,
	"metaRow": `TaskRow-module__metaRow___yvWs0`,
	"statusCell": `TaskRow-module__statusCell___xsxIZ`,
	"childCountBadge": `TaskRow-module__childCountBadge___NA8M8`,
	"childCountBadgeItem": `TaskRow-module__childCountBadgeItem___PCTjM`,
	"childCountBadgeIcon": `TaskRow-module__childCountBadgeIcon___pwuDJ`,
	"childCountBadgeDivider": `TaskRow-module__childCountBadgeDivider___EK33V`,
	"priorityCell": `TaskRow-module__priorityCell___T5iOw`,
	"assignCell": `TaskRow-module__assignCell___bP8Io`,
	"systemBadge": `TaskRow-module__systemBadge___FoYvH`,
	"priorityBadge": `TaskRow-module__priorityBadge___cj9T6`,
	"copyButton": `TaskRow-module__copyButton___C5voL`,
	"copyIcon": `TaskRow-module__copyIcon___PFhSY`,
	"priorityBadgecritical": `TaskRow-module__priorityBadgecritical___kKr1e`,
	"priorityBadgehigh": `TaskRow-module__priorityBadgehigh___VqUzM`,
	"priorityBadgemedium": `TaskRow-module__priorityBadgemedium___rcMkk`,
	"priorityBadgelow": `TaskRow-module__priorityBadgelow___CGs4g`,
	"assignButton": `TaskRow-module__assignButton___hGzcE`,
	"assignButtonOver": `TaskRow-module__assignButtonOver___w3UKW`,
	"assignButtonBreach": `TaskRow-module__assignButtonBreach___uawMa`,
	"claimCapacityBanner": `TaskRow-module__claimCapacityBanner___yTmgc`,
	"claimCapacityBannerOver": `TaskRow-module__claimCapacityBannerOver___FCjnK`,
	"claimCapacityBannerBreach": `TaskRow-module__claimCapacityBannerBreach___svABl`,
	"claimCapacityBannerRow": `TaskRow-module__claimCapacityBannerRow___Ek5DZ`,
	"claimCapacityIcon": `TaskRow-module__claimCapacityIcon___mqXtF`,
	"claimCapacityIconOver": `TaskRow-module__claimCapacityIconOver___r5rUN`,
	"claimCapacityIconBreach": `TaskRow-module__claimCapacityIconBreach___oy2jN`,
	"claimCapacityBannerText": `TaskRow-module__claimCapacityBannerText___SwWTT`,
	"tOver": `TaskRow-module__tOver___sB5B9`,
	"tBreach": `TaskRow-module__tBreach___PEjgG`,
	"claimCapacityMeterWrap": `TaskRow-module__claimCapacityMeterWrap___yodZW`,
	"claimCapacityTrack": `TaskRow-module__claimCapacityTrack___e4H0q`,
	"claimCapacityFillAmber": `TaskRow-module__claimCapacityFillAmber___DyJ7W`,
	"claimCapacityFillRed": `TaskRow-module__claimCapacityFillRed___pomKN`,
	"claimCapacityFillAmberHatch": `TaskRow-module__claimCapacityFillAmberHatch___k9GeF`,
	"claimCapacityFillRedHatch": `TaskRow-module__claimCapacityFillRedHatch___vTFEg`,
	"claimCapacityTickNow": `TaskRow-module__claimCapacityTickNow____YEe8`,
	"claimCapacityTickCap": `TaskRow-module__claimCapacityTickCap___vu05P`,
	"claimCapacityLabels": `TaskRow-module__claimCapacityLabels___MaMET`,
	"claimCapacityLabelNow": `TaskRow-module__claimCapacityLabelNow___GrC8d`,
	"claimCapacityLabelCap": `TaskRow-module__claimCapacityLabelCap___FmRmg`,
	"dueText": `TaskRow-module__dueText___laLQW`,
	"dueUrgent": `TaskRow-module__dueUrgent____QpWw`,
	"linkedToggle": `TaskRow-module__linkedToggle___Xgkev`,
	"linkedToggleChevron": `TaskRow-module__linkedToggleChevron___Q1Skf`,
	"linkedToggleIcon": `TaskRow-module__linkedToggleIcon___DypCc`,
	"linkedToggleChevronOpen": `TaskRow-module__linkedToggleChevronOpen___dU6Sx`
};
module.exports = ___CSS_LOADER_EXPORT___;
